import {html, LitElement, TemplateResult} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import {styleMap} from "lit/directives/style-map.js";
import playerStyles from "../../../../styles/minigames/dragoninvaders/playerStyles";

@customElement("player-wizard")
export class PlayerWizard extends LitElement {
    @property({type: Number}) public position: number = 50;
    @state() private lastShotTime: number = 0;
    private keysPressed: { [key: string]: boolean } = {};

    public static styles = [playerStyles];

    public constructor() {
        super();
        window.addEventListener("keydown", (e) => this.handleKeyDown(e));
        window.addEventListener("keyup", (e) => this.handleKeyUp(e));
        this.startMovementLoop();
    }

    public disconnectedCallback(): void {
        super.disconnectedCallback();
    }

    private handleKeyDown(e: KeyboardEvent): void {
        this.keysPressed[e.code] = true;
    }

    private handleKeyUp(e: KeyboardEvent): void {
        this.keysPressed[e.code] = false;
    }

    private updatePositionAndShoot(): void {

        // This method gets called within your movement loop, after updating the position
        this.dispatchEvent(new CustomEvent("player-position-change", {
            detail: {
                positionX: this.position,
            },
            bubbles: true, // This makes the event bubble up through the DOM
            composed: true // This allows the event to cross the shadow DOM boundary
        }));
    }

    private startMovementLoop(): void {
        const loop: (time: number) => void = (time: number) => {
            if (this.keysPressed["ArrowLeft"]) {
                this.position = Math.max(0, this.position - 0.5);
            }
            if (this.keysPressed["ArrowRight"]) {
                this.position = Math.min(100, this.position + 0.5);
            }
            if (this.keysPressed["Space"] && time - this.lastShotTime > 500) {
                this.shoot();
                this.lastShotTime = time;
            }
            this.updatePositionAndShoot();
            this.requestUpdate();
            requestAnimationFrame(loop);
        };
        requestAnimationFrame(loop);
    }

    private shoot(): void {
        const playerShip: Element = this.shadowRoot?.firstElementChild as Element;
        const parentNode: Element = this.offsetParent as Element;

        const gameBoardRect: DOMRect = parentNode.getBoundingClientRect();
        const shipRect: DOMRect = playerShip.getBoundingClientRect();

        const positionX: number = shipRect.left + (shipRect.width / 2) - gameBoardRect.left;
        const positionY: number = shipRect.top - gameBoardRect.top - 20;

        this.dispatchEvent(new CustomEvent("shoot", {
            detail: {positionX, positionY},
            bubbles: true,
            composed: true
        }));
    }

    protected render(): TemplateResult {
        const shipStyles: { transform: string; left: string } = {
            left: `${this.position}%`,
            transform: "translateX(-50%)",
        };
        return html`
            <div class="player" style=${styleMap(shipStyles)}></div>`;
    }
}
